import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customerActions } from "stores/customer/customerActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { thirdpartyActions } from "stores/thirdparty/thirdpartyActions";

const mapStateToProps = (state) => {
  return {
    renewalPricingDetails: state.customer.renewalPricingDetails,
    isLoading: state.customer.loading.renewalPricingDetails,

    subscriptionPlans: state.thirdparty.subscriptionPlans,
    isSubscriptionPlansLoading: state.thirdparty.loading.subscriptionPlans,
    isSubscriptionPlansCalled:
      state.thirdparty.isInitialCalled.subscriptionPlans,

    // Investment Amount.
    minInvestmentAmount:
      state.onboarding.minInvestmentAmount ||
      state.jarvisPrime.primeOnboarding.minInvestmentAmount,
    onBoardingInvestmentAmount:
      state.onboarding.investmentAmount ||
      state.jarvisPrime.primeOnboarding.investmentAmount,
    customerProfileData: state.customer.profile,
    sourceType: state.onboarding.sourceType,
    isAllInOneSubscriptionActive: state.onboarding.isAllInOneSubscriptionActive,
    allInOnePlanFrequency: state.onboarding.allInOnePlanFrequency,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRenewSubscriptionAction: customerActions.getRenewalPricingDetails,
      getSubscriptionPlansAction: thirdpartyActions.getSubscriptionPlans,
      getProfileDataAction: customerActions.getProfile,
      updatePrimeOnboardingDataAction:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      updateOnboardingDataAction: onboardingActions.updateOnboardingData,
    },
    dispatch,
  );

const PlanAndPricingStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default PlanAndPricingStore;
